import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

type Teams =
    | 'RedBarclays'
    | 'PorkChopExpress'
    | 'BinaryBrains'
    | 'FrontEndSquad'
    | 'Unknown'
    | 'Elevation'
    | 'CrossTeam'
    | 'WorksOnMyMachine';
const TeamAbbreviations: Record<Teams, string> = {
    RedBarclays: 'RB',
    PorkChopExpress: 'PCE',
    BinaryBrains: 'BB',
    Elevation: 'EV',
    CrossTeam: 'AUT',
    FrontEndSquad: 'FES',
    WorksOnMyMachine: 'WOMM',
    Unknown: '',
};

type TeamSummary = {
    total: number;
    percentage: number;
};

export function build(element: HTMLElement, teams: Record<Teams, TeamSummary>) {
    let root = am5.Root.new(element);

    root.setThemes([am5themes_Animated.new(root)]);
    root.container.set('layout', root.verticalLayout);

    let chartContainer = root.container.children.push(
        am5.Container.new(root, {
            layout: root.horizontalLayout,
            width: am5.p100,
            height: am5.p50,
        }),
    );

    let chart = chartContainer.children.push(
        am5percent.PieChart.new(root, {
            endAngle: 270,
        }),
    );

    let series = chart.series.push(
        am5percent.PieSeries.new(root, {
            valueField: 'value',
            categoryField: 'category',
            endAngle: 270,
        }),
    );

    series.states.create('hidden', {
        endAngle: -90,
    });

    series.slices.template.set('tooltipText', '[bold]{category}[/]:{value}');

    series.data.setAll(
        Object.entries(teams)
            .filter(([key, value]) => value.total > 0)
            .map(([key, value]) => ({
                category: !!TeamAbbreviations[key]?.length
                    ? TeamAbbreviations[key]
                    : 'Unknown',
                value: value.total,
            })),
    );

    series.appear(1000, 100);

    return series;
}

export function update(
    series: am5percent.PieSeries,
    teams: Record<Teams, TeamSummary>,
) {
    series.data.setAll(
        Object.entries(teams)
            .filter(([key, value]) => value.total > 0)
            .map(([key, value]) => ({
                category: !!TeamAbbreviations[key]?.length
                    ? TeamAbbreviations[key]
                    : 'Unknown',
                value: value.total,
            })),
    );

    return series;
}
